import classNames from 'classnames';
import PropTypes from 'prop-types';

const ModernTvIcon = ({ className }) => {
  return (
    <svg
      className={classNames('modern-tv-icon', className)}
      width='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.04199 2.0835C1.04199 1.73832 1.32181 1.4585 1.66699 1.4585H18.3337C18.6788 1.4585 18.9587 1.73832 18.9587 2.0835V15.4168C18.9587 15.762 18.6788 16.0418 18.3337 16.0418H1.66699C1.32181 16.0418 1.04199 15.762 1.04199 15.4168V2.0835Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.3342 18.542H6.66699V17.292H13.3342V18.542Z'
        fill='currentColor'
      />
    </svg>
  );
};

ModernTvIcon.propTypes = {
  className: PropTypes.string,
};

export default ModernTvIcon;
